export default __webpack_public_path__ + "static/media/img999.c6f94cc9.JPG";